import { auth } from '../config/firebase';
import type { ClinicalTrial, TrialMatch } from '@researcher/shared';
import { apiUrl } from '../config/api';

async function getHeaders(requireAuth = false): Promise<HeadersInit> {
  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    headers['Authorization'] = `Bearer ${token}`;
  } else if (requireAuth) {
    throw new Error('Authentication required');
  }

  return headers;
}

export async function searchTrials(query: string, status?: string): Promise<ClinicalTrial[]> {
  const headers = await getHeaders();
  const params = new URLSearchParams({ q: query });
  if (status) params.set('status', status);

  const response = await fetch(`${apiUrl('/trials/search')}?${params}`, { headers });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to search trials');
  }

  return data.data || [];
}

export async function fetchTrialMatches(): Promise<TrialMatch[]> {
  const headers = await getHeaders(true);

  const response = await fetch(apiUrl('/trials/matches'), { headers });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to fetch trial matches');
  }

  return data.data || [];
}
